import { usePathname } from "expo-router";

export const usePathIncludes = () => {
  const segments = usePathname().split("/").slice(1);

  const match = (segment: string) => {
    return segments.includes(segment);
  };

  return { match };
};
